/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

const base = (state) => state.tecdoc;

export const makeSelectVehiculesBrands = () => createSelector(
  [base], (tecdoc) => tecdoc.vehicules.brands,
);
